<expert-document-item #expertDocumentItem [model]="model" [extended]="true" [isDocumentDisplay]="true" [documentType]="documentType" [documentsNavigator]="documentsNavigator"
    (close)="this.close.emit()" (onConfirmationDialog)="showConfirmationDialog($event)">
<expert-document-item>